import styled from 'styled-components';
import { isPortrait, widthEm, heightEm } from '../../utils/size';

export const Container = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    background-color: white;
    margin: 1em 1em 1.3125em;
`;

export const ContainerStyled = styled(Container)`
    flex-direction: row;
    ${() => (isPortrait() ? 'display: inline-block;' : '')};
`;

const questionTextFontSize = (isLongTitle, answersLength) => {
    if (widthEm() < 30 && heightEm() < 30) {
        return '14px';
    } else if (widthEm() < 30) {
        return isLongTitle && answersLength > 3 ? '18px' : '21px';
    } else if (widthEm() < 33) {
        return isLongTitle && answersLength > 3 ? '22px' : '26px';
    } else if (widthEm() < 38) {
        return isLongTitle && answersLength > 3 ? '22px' : '25px';
    } else if (widthEm() < 39.5) {
        return isLongTitle && answersLength > 3 ? '24px' : '28px';
    }
    return isLongTitle && answersLength > 3 ? '22px' : '28px';
};

const questionTextLineHeight = (isLongTitle, answersLength) => {
    if (widthEm() < 30 && heightEm() < 30) {
        return '16px';
    } else if (widthEm() < 30) {
        return isLongTitle && answersLength > 3 ? '22px' : '25px';
    } else if (widthEm() < 33) {
        return isLongTitle && answersLength > 3 ? '30px' : '30px';
    } else if (widthEm() < 38) {
        return isLongTitle && answersLength > 3 ? '26px' : '30px';
    } else if (widthEm() < 39.5) {
        return isLongTitle && answersLength > 3 ? '28px' : '36px';
    }
    return isLongTitle && answersLength > 3 ? '30px' : '36px';
};

export const QuestionText = styled.div`
    background-color: white;
    font-size: ${props => questionTextFontSize(props.isLongTitle, props.answersLength)};
    line-height: ${props =>
        questionTextLineHeight(props.isLongTitle, props.answersLength)};
    color: #333;
    font-weight: ${() => (isPortrait() ? 'normal' : '300')};
    margin-top: 24px;
    overflow: hidden;
`;

export const PeopleAnswered = styled.div`
    font-size: ${props =>
        widthEm() < 22 && props.textSize !== 'small' ? '12px' : '9px'};
    line-height: 16px;
    letter-spacing: 2px;
    color: #c9c3c3;
    font-weight: bold;
    margin-top: ${props => (props.topMargin === 'small' ? '10px' : '16px')};
`;

const LegalInfoWrapper_OrientationBasedRules = () => {
    if (isPortrait()) {
        return `
            padding: 0;
            bottom: -10px;
        `;
    }
    return `bottom: 12px;`;
};

export const LegalInfoWrapper = styled.div`
    position: absolute;
    left: 0;
    padding-right: 15px;
    ${() => LegalInfoWrapper_OrientationBasedRules()};
`;

const FormWrapper_OrientationBasedRules = isElectionReminder => {
    if (isPortrait()) {
        return `
            height: ${isElectionReminder ? `335px` : `83%`};
            width: 100%;
            position: relative;

            @media (min-width: 355px) {
                height: 350px;
            }
    `;
    }
    return 'width: 68%;';
};

export const FormWrapper = styled.div`
    ${props => FormWrapper_OrientationBasedRules(props.isElectionReminder)};
`;

export const AnimationContainer = styled.div`
    &.transition-enter {
        opacity: 0;
    }

    &.transition-enter.transition-enter-active {
        transition: opacity 0.35s;
        transition-timing-function: ease-out;
        opacity: 1;
    }

    &.transition-exit {
        opacity: 1;
    }

    &.transition-exit.transition-exit-active {
        transition: opacity 0.25s;
        transition-timing-function: ease-out;
        opacity: 0;
    }
`;

export const ContainerAbsolute = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(255, 255, 255, 0.9);
    z-index: 2;
`;

export const Body = styled.div`
    width: 436px;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 4px 8px 0 rgba(42, 42, 42, 0.1);
    padding: 1.5em;
    background-color: rgba(255, 255, 255, 1);
    border: 1px solid #f1f1f1;

    ${() => (isPortrait() ? 'width: calc(100% - 2em);' : '')};
`;
